import styled, { css } from "styled-components";
import { Atom } from 'AppReact';

const Title = styled.div`
  ${({ theme, displayState }) => css`
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.1px;
    margin-right: ${displayState?.mr ?? '18px'};
    color: ${displayState.selected ? theme?.colour?.secondary : `${theme?.colour?.secondary}B3`};
    font-weight: ${displayState.selected ? 600 : 400};

    cursor: pointer;

    &:hover {
      color: ${theme?.colour?.secondary};
      font-weight: 600;
    }

    @media only screen and (min-width: 768px) {
      font-size: 24px;
      line-height: 24px;
    }
  `}
`;

export default Atom({ type: 'button', dataType: 'string', template: Title })